<mat-card class="url-card">
  <mat-card-header>
    <mat-card-title>{{ cardHeader | translate }}</mat-card-title>
    <mat-card-subtitle>{{ description | translate }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="link-and-lock">
      <mat-form-field>
        <div class="input-field">
          <input [disabled]="true" matInput value="{{ reviewPageUrl }}" />
          <mat-icon class="lock-icon">lock_outline</mat-icon>
        </div>
      </mat-form-field>
    </div>
    @if (hintText) {
      <div [innerHTML]="hintText | translate" class="hint-text"></div>
    }
  </mat-card-content>
  <mat-card-actions>
    <button
      (cdkCopyToClipboardCopied)="reviewPageURLCopied($event)"
      [cdkCopyToClipboard]="reviewPageUrl"
      color="primary"
      mat-flat-button
      >
      {{ 'SETTINGS.REVIEW_PAGE_URLS.COPY_TO_CLIPBOARD' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
